import React from "react";
import { connect } from "react-redux";
import { array, string } from "prop-types";
import sortBy from "lodash/sortBy";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import AuthorDetails from "../../molecules/author-details";

import { filterAlumnusAuthors } from "../../helper/utils";

import "./people-team.m.css";

const PeopleTeamRow = ({ authors = [], authorList, headerText = "People" }) => {
  const newAuthors = filterAlumnusAuthors(authorList, authors);
  const sortedAuthorsList = sortBy(newAuthors, [e => e.name]);

  if (!(sortedAuthorsList && sortedAuthorsList.length)) {
    return null;
  }

  return (
    <div className="container">
      <div styleName="header-wrapper">
        <Headline headerType={7} headerLevel={2} text={headerText} />
      </div>
      <div styleName="content">
        {sortedAuthorsList.map((author, index) => (
          <AuthorDetails key={index} author={author} />
        ))}
      </div>
    </div>
  );
};

PeopleTeamRow.propTypes = {
  authors: array,
  authorList: array,
  headerText: string
};

const mapStateToProps = state => {
  return {
    authorList: get(state, ["peopleReducer"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(PeopleTeamRow);
